import PropTypes from 'prop-types';
import RightSidebar from './RightSidebar';
import './RightSidebar.css';
import './ContactDetailsSidebar.css';
import { useUserPresence } from '../../hooks/useUserPresence';
import { getPresenceColor, getPresenceTitle } from '../../utils/presenceUtils';
import { generateInitialsAvatar } from '../../utils/avatar';

const ContactDetailsSidebar = ({ contact, onClose }) => {
  const { getPresence, isOnline } = useUserPresence();
  if (!contact) return null;
  const userId = contact.user?.userId;
  const displayName = contact.user?.displayName || userId || '';
  const avatarUrl = contact.avatar || generateInitialsAvatar(displayName);
  const presenceObj = userId ? getPresence(userId) : null;
  const online = userId ? isOnline(userId) : false;
  return (
    <RightSidebar
      onClose={onClose}
      title={'Contact Details'}
    >
      <div className="contact-details-sidebar">
        <div className="contact-details-avatar">
          <img
            src={avatarUrl}
            alt={displayName.charAt(0).toUpperCase()}
            className="contact-details-avatar-img"
            onError={e => { e.target.src = generateInitialsAvatar(displayName); }}
          />
          {userId && (
            <div
              className="contact-details-presence-indicator"
              style={{ backgroundColor: getPresenceColor(presenceObj, online) }}
              title={getPresenceTitle(presenceObj, online)}
            />
          )}
        </div>
        <div className="contact-details-name">{displayName}</div>
        {userId && (
          <div className="contact-details-info"><strong>UserId:</strong> {userId}</div>
        )}
        {(!online && contact.user?.lastActiveAgo) && (
          <div className="contact-details-info"><strong>Last Active:</strong> {Math.round(contact.user.lastActiveAgo / 1000)} Seconds Ago</div>
        )}
      </div>
    </RightSidebar>
  );
};

ContactDetailsSidebar.propTypes = {
  contact: PropTypes.object,
  onClose: PropTypes.func,
};

export default ContactDetailsSidebar;
